import styled from "styled-components"

const Container = styled.section`
  margin: 3em 0;
  border-radius: 8px;
  overflow: hidden;
  background: #f4f5f6;
  position: relative;
  transition: all 0.15s ease-out;
`

const Title = styled.span`
  display: block;
  font-size: 2.2rem;
  font-weight: 700;
  color: ${props => props.theme.colors.text.dark};
  line-height: 1.12;
`

const Description = styled.span`
  display: block;
  font-size: 1.7rem;
  color: #686f76;
  line-height: 1.4;
  margin: 16px 0 0;
`

const Button = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 1.4rem;
  font-weight: 500;
  height: 32px;
  padding: 0 16px;
  color: #fff;
  background: #03192d;
  border-radius: 8px;
  margin: 20px 0 0;
`

export { Container, Title, Description, Button }
